import { createContext, type PropsWithChildren, useContext } from "react";

import { getPortalRoot } from "../../use-cases/manage/grid/utils/getPortalRoot";

const portalRoot = getPortalRoot();

// This context is to fix dropdown menu positioning when the dropdown is inside a modal. Without this, dropdown menu content is outside the viewport.
// We explicitly override the default portal root with undefined to render the dropdown menu content next to the input field in the DOM.

const DropdownMenuPortalTargetContext = createContext<
  HTMLElement | null | undefined
>(null);
DropdownMenuPortalTargetContext.displayName = "DropdownMenuPortalTargetContext";

export function DropdownMenuPortalTargetProvider({
  children,
}: PropsWithChildren) {
  return (
    <DropdownMenuPortalTargetContext.Provider value={undefined}>
      {children}
    </DropdownMenuPortalTargetContext.Provider>
  );
}

export const useDropdownMenuTargetPortal = () => {
  const override = useContext(DropdownMenuPortalTargetContext);
  return override !== null ? override : portalRoot;
};
